export default {
      id: "sensors__coolant_temperature-usage",
      viewBox: "0 0 20 29",
      url: __webpack_public_path__ + "img/icons.svg#sensors__coolant_temperature",
      toString: function () {
        return this.url;
      }
    }